import React from 'react';
import Main from '../Components/Main/Main';
// import Projects from "../Components/Projects/Projects";

const Homepage = () => {
  return (
    <>
      <Main />
      {/* <Projects/> */}
    </>
  );
};

export default Homepage;
